import { useForm } from "react-hook-form";
import TextArea from "../../../components/form-controls/TextArea";
import { useEffect, useMemo } from "react";
import { AutomaticResponsesService } from "../../../services/AutomaticResponsesService";
import Button from "../../../components/form-controls/Button";
import { AlertService } from "../../../services/Alert";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { useTranslation } from "react-i18next";import useRequest from "../../../hooks/useRequest";
import Loader from "../../../components/Loader";
{}
enum RequestStatusType {
    WELCOME = 'setStatusWelcomeMessage',
    GOODBYE = 'setStatusGoodbyeMessage',
    OUT_HOURS = 'setStatusOutHoursMessage',
    DAY_OFF = 'setStatusDayOffMessage',
}

enum RequestMessageType {
    WELCOME = 'updateWelcomeMessage',
    GOODBYE = 'updateGoodbyeMessage',
    OUT_HOURS = 'updateOutHoursMessage',
    DAY_OFF = 'updateDayOffMessage',
}

function AutomaticResponsesPartial() {
    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const { account } = useCurrentAccount();

    const defaultValues = {
        id: 0,
        account_id: 0,
        welcome_message: '',
        welcome_status: 0,
        bye_message: '',
        bye_status: 0,
        out_hours_message: '',
        out_hours_status: 0,
        business_day_message: '',
        business_day_status: 0
    }

    const { register, watch, handleSubmit, getValues, reset, formState: { errors, isValid, isSubmitting,  } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const welcome_status = watch('welcome_status')
    const bye_status = watch('bye_status')
    const out_hours_status = watch('out_hours_status')
    const business_day_status = watch('business_day_status')

    const getMessages = async() => {
        const { data } = await call(() => AutomaticResponsesService.getMessages(account.id));
        reset(data)
    }

    const handleStatusMessage = async(method: RequestStatusType, key: string, status: 0 | 1) => {
        
        const isConfirmed = await AlertService.warning('¡Aviso!',`¿Estás seguro de querer ${status? 'activar': 'desactivar'} esta opción?`, async () => {
            try {

                await request(method, { account_id: account.id, [key]: status })
                await getMessages()
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al guardar la configuración, intenta nuevamente')
            }
        });

        if (isConfirmed) {
            AlertService.toastSuccess('Se guardó la configuración correctamente')
        }
    }

    const updateMessage = async(method: RequestMessageType, key: any) => {
        
        

        const promise = async() => {
            const message = getValues(key);
            await request(method, { account_id: account.id, [key]: message })
            await getMessages()
        }

        AlertService.toastLoading( promise(), 'Guardando...', 'Se guardó el mensaje correctamente', 'Ocurrió un error al guardar el mensaje, intenta nuevamente' )
    }

    const request = async(method: RequestStatusType | RequestMessageType, payload: any) => {
        const  { data } = await AutomaticResponsesService[method](payload);
        return data
    }

    useEffect(() => {
        getMessages()
    }, [])
    

    const heightRequesting = useMemo(()=> {return isRequesting ? 'h-400':''},[isRequesting]);
    return (
        <>
            <div className="card">

                <div className="card-header d-flex align-items-center">
                    <div className="me-3">
                        <h2 className="card-title h4">  {t("config.automatic-responses.automatic-title")}</h2>
                    </div>

                </div>

                <div className={`card-body relative ${heightRequesting}`}>
                    {
                        isRequesting ? <Loader/> :
                    <>
                    <div className="row">
                        <div className="col-5">
                            <h5>  {t("config.automatic-responses.message-title")}</h5>
                            <p>  {t("config.automatic-responses.message-p")}</p>                            
                        </div>
                        <div className="col-7">
                            {
                                welcome_status ? (
                                    <>
                                        <div className="mb-3">
                                            <TextArea
                                                label= {t("config.automatic-responses.message-label")}
                                                errors={errors.welcome_message }
                                                {...register('welcome_message', { required: true })} />
                                        </div>
                                        <div className="text-end">
                                            <button  className="btn btn-soft-danger btn-sm me-3" onClick={() => handleStatusMessage(RequestStatusType.WELCOME, 'welcome_status', 0)}>  {t("config.automatic-responses.disable")}</button>
                                            <Button  className="btn btn-primary btn-sm"  isLoading={isSubmitting} onClick={ () => updateMessage(RequestMessageType.WELCOME, 'welcome_message') }>  {t("config.automatic-responses.save-btn")}</Button>
                                        </div>
                                    </>
                                ) : (
                                    <div className="text-center">
                                        <img src="/assets/img/robot.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />
                                        <button  className="btn btn-primary btn-sm"onClick={() => handleStatusMessage(RequestStatusType.WELCOME, 'welcome_status', 1)}>  {t("config.automatic-responses.enable")}</button>
                                    </div>
                                )
                            }
                            
                        </div>
                    </div>
                    <hr />

                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.automatic-responses.message-label-goodbye")}</h5>
                            <p>{t("config.automatic-responses.message-p-goodbye")}</p>
                        </div>
                        <div className="col-7">
                            {
                                bye_status ? (
                                    <>
                                        <div className="mb-3">
                                            <TextArea
                                                label={t("config.automatic-responses.message-label")}
                                                errors={errors.bye_message }
                                                {...register('bye_message', { required: true })} />
                                        </div>
                                        <div className="text-end">
                                            <button  className="btn btn-soft-danger btn-sm me-3" onClick={() => handleStatusMessage(RequestStatusType.GOODBYE, 'bye_status', 0)}>{t("config.automatic-responses.disable")}</button>
                                            <Button  className="btn btn-primary btn-sm"  isLoading={isSubmitting} onClick={() => updateMessage(RequestMessageType.GOODBYE, 'bye_message')}>{t("config.automatic-responses.save-btn")}</Button>
                                        </div>
                                    </>
                                ) : (
                                     <div className="text-center">
                                        <img src="/assets/img/goodbye.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />
                                        <button  className="btn btn-primary btn-sm" onClick={() => handleStatusMessage(RequestStatusType.GOODBYE, 'bye_status', 1)}>{t("config.automatic-responses.enable")}</button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <hr />

                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.automatic-responses.message-out-time")}</h5>
                            <p>{t("config.automatic-responses.message-out-time-p")}</p>
                        </div>
                        <div className="col-7">
                            {
                                out_hours_status ? (
                                    <>
                                        <div className="mb-3">
                                            <TextArea
                                                label={t("config.automatic-responses.message-label")}
                                                errors={errors.out_hours_message }
                                                {...register('out_hours_message', { required: true })} />
                                        </div>
                                        <div className="text-end">
                                            <button  className="btn btn-soft-danger btn-sm me-3" onClick={() => handleStatusMessage(RequestStatusType.OUT_HOURS, 'out_hours_status', 0)}>{t("config.automatic-responses.disable")}</button>
                                            <Button  className="btn btn-primary btn-sm"  isLoading={isSubmitting} onClick={() => updateMessage(RequestMessageType.OUT_HOURS, 'out_hours_message')}>{t("config.automatic-responses.save-btn")}</Button>
                                        </div>
                                    </>
                                ) : (
                                     <div className="text-center">
                                        <img src="/assets/img/no-alarm.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />
                                        <button  className="btn btn-primary btn-sm" onClick={() => handleStatusMessage(RequestStatusType.OUT_HOURS, 'out_hours_status', 1)}>{t("config.automatic-responses.enable")}</button>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                    <hr />

                    <div className="row">
                        <div className="col-5">
                            <h5>{t("config.automatic-responses.message-day")}</h5>
                            <p>{t("config.automatic-responses.message-day-p")}</p>
                        </div>
                        <div className="col-7">
                            {
                                business_day_status ? (
                                    <>
                                        <div className="mb-3">
                                            <TextArea
                                                label={t("config.automatic-responses.message-label")}
                                                errors={errors.business_day_message }
                                                {...register('business_day_message', { required: true })} />
                                        </div>
                                        <div className="text-end">
                                            <button  className="btn btn-soft-danger btn-sm me-3" onClick={() => handleStatusMessage(RequestStatusType.DAY_OFF, 'business_day_status', 0 )}>{t("config.automatic-responses.disable")}</button>
                                            <Button  className="btn btn-primary btn-sm"  isLoading={isSubmitting} onClick={() => updateMessage(RequestMessageType.DAY_OFF, 'business_day_message')}>{t("config.automatic-responses.save-btn")}</Button>
                                        </div>
                                    </>
                                ) : (
                                     <div className="text-center">
                                        <img src="/assets/img/day-off.png" className=" d-block m-auto mb-3" style={{ height: '100px' }} />
                                        <button  className="btn btn-primary btn-sm" onClick={() => handleStatusMessage(RequestStatusType.DAY_OFF, 'business_day_status', 1)}>{t("config.automatic-responses.enable")}</button>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    


                    {/* <div className="d-flex justify-content-end">
                        <Button  className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>Guardar</Button>
                    </div> */}
                    </>
                }
                </div>
            </div>
        </>
    )
}
export default AutomaticResponsesPartial